import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { browserHistory } from 'react-router'
import { Agreement, Button, Toast } from 'react-weui'
import { Page } from '../../components'
import { storage, isLZWKAPP } from '../../utils'
import '../../css/page/LiveroomLecturerPage.css'
import config from '../../config'


class LiveroomCreateInfoPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isAgree: true,
            isFollow: true,
            isPending: false,
            isShowRebateModal: false,
            qrImg: '',
        }
    }
    componentDidMount () {
        document.title = '欢迎入驻'
        this.fetchData()
        storage.setItem('liveroom_create_is_follow', true)
    }

    fetchData () {
        this.setState({ isPending: true })
        const inviterId = this.props.location.query.inviter_id
        const st = this.props.location.query.st
        let apiParams = {}
        if (inviterId) {
            apiParams = { inviter_id: inviterId }
        }
        if (st) {
            apiParams = { ...apiParams, st }
        }
        axios.get('/api/liveroom/my', {
            params: apiParams
        })
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code === 0) {
                    this.setState({ isPending: true })
                    const st = this.props.location.query.st
                    if (st) {
                        this.toRebatePage('rebate_liveroom')
                    } else {
                        location.replace(`/liveroom/${res.data.data.liveroom.id}`)
                    }
                }
            })
    }
    getIsDisabled () {
        return !this.state.isAgree
    }
    onSubmit () {
        this.setState({ isPending: true })
        if (this.props.location.query.fr) {
            storage.setItem('liveroom_create_fr', this.props.location.query.fr)
        } else {
            storage.removeItem('liveroom_create_fr')
        }
        if (this.props.location.query.inviter_id) {
            storage.setItem('liveroom_create_inviter_id', this.props.location.query.inviter_id)
        } else {
            storage.removeItem('liveroom_create_inviter_id')
        }
        axios.get('/api/liveroom/create/info')
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return location.assign('/account/edit/phone?type=liveroom-create')
                }
                location.assign('/liveroom/create')
            })
    }
    onChangeAgreement (type, e) {
        this.setState({ [type]: e.target.checked })
        if (type === 'isFollow') {
            storage.setItem('liveroom_create_is_follow', e.target.checked)
        }
    }
    toRebatePage (fr) {
        this.setState({ isPending: true })
        axios.get('/api/account/ticket')
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code === 0) {
                    if (fr === 'rebate_create_liveroom') {
                        location.assign(`http://rebate.lycheer.cn/specials/activity/liveroom_create_rebate?__ticket=${res.data.data.ticket}&fr=${fr}`)
                    } else {
                        location.replace(`http://rebate.lycheer.cn/specials/activity/liveroom_create_rebate?__ticket=${res.data.data.ticket}&fr=${fr}`)
                    }
                }
            })
    }
    render() {
        return (
            <Page>
                <div className="wk-inner-page liveroom-create-page guide">
                    <div className="cover margin-bottom">
                        <img src="https://static-cos.lycheer.net/xupload/20180910_1.jpg"/>
                        <img src="https://static-cos.lycheer.net/xupload/20180910_2.jpg"/>
                        <img src="https://static-cos.lycheer.net/picture/7832811_65216147a637c78b46657448b6f865b1.jpg"/>
                    </div>
                    <div className='margin-bottom'>
                        <Agreement className='padding-b-0' checked={this.state.isAgree} onChange={e => this.onChangeAgreement('isAgree', e)}>
                            &nbsp;&nbsp;我同意遵循 <a href={`${config.WK_GW}/secondary/protocol.html`}>《荔课平台用户协议》</a>
                        </Agreement>
                        <Agreement className='padding-b-0' checked={this.state.isFollow} onChange={e => this.onChangeAgreement('isFollow', e)}>
                            &nbsp;&nbsp;关注 <a href={isLZWKAPP() ? 'lizhiweike://liveroom?liveroom_id=23715304' : '/liveroom/23715304'}>微课大学</a> 及时了解店铺运营技巧
                        </Agreement>
                        <div className="wk-btn-90" style={{bottom: "0"}}>
                            <Button onClick={e => this.onSubmit(e)} disabled={this.getIsDisabled()}>
                                开通店铺
                            </Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}/>
            </Page>
        )
    }
}


export default connect(state => ({
    account: state.account
}))(LiveroomCreateInfoPage)



// WEBPACK FOOTER //
// ./src/pages/liveroomCreate/LiveroomCreateGuidePage.js